import { useQuery } from "@apollo/client/react";
import GET_CLIENT_RELATIONSHIP from "../../queries/client/getClientRelationship";
import type { ClientRelationshipModel } from "../../../models/ClientRelationshipModel";

export const useClientRelationship = (
  open: boolean,
  clientIdentifier?: string,
  recipientClientIdentifier?: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    clientRelationship: ClientRelationshipModel;
  }>(GET_CLIENT_RELATIONSHIP, {
    skip: !open || (!clientIdentifier && !recipientClientIdentifier),
    variables: { clientIdentifier, recipientClientIdentifier },
  });
  return {
    clientRelationship: data?.clientRelationship,
    error,
    loading,
    refetch,
  };
};
